<template>
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GameBanner :fake_counter="fakeCounter" />

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-60 mobile-min-height"
    >
      <div class="d-flex-row flex-15 t-white">
        <NestPackSelector />
      </div>

      <div
        class="d-flex-column flex-85 justify-start align-start t-white gap-42"
      >
        <div class="category_pack_container">
          <PackCard
            v-for="(pack, index) in packs"
            :title="pack.short_title"
            :perks="pack.perks"
            :image="pack.image"
            :slug="pack.slug"
            :link="`/${currentGameSlug}/${pack.slug}`"
            :index="index"
            :current-game-slug="currentGameSlug"
            :is-new="pack.is_new"
            :slider-chip="false"
          />
        </div>

        <div class="d-flex-column justify-start" style="margin-top: 24px">
          <div class="d-flex-column gap-0">
            <p
              class="t-orange regular-l f-w-500 font-family-1"
              style="letter-spacing: 2px"
            >
              {{ $t("homepage.faq") }}
            </p>
            <h2
              class="t-white font-family-1 title-h2 f-w-600"
              style="text-align: center"
            >
              {{ $t("homepage.got_a_question") }}
              <br />
              {{ $t("homepage.we_have")
              }}<span class="t-light-orange">{{ $t("homepage.answers") }}</span
              >!
            </h2>
          </div>

          <div class="d-flex-row align-start lg-row-to-col">
            <div class="d-flex-column gap-0">
              <Faq :faqs="[...gameFaqs].splice(0, 4)" variant="pack twocol" />
            </div>
            <div class="d-flex-column gap-0">
              <Faq :faqs="[...gameFaqs].splice(4, 6)" variant="pack twocol" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import GameBanner from "../banners/GameBanner.vue";
import PackCard from "~/components/cards/PackCard.vue";
import NestPackSelector from "../sections/boosting/NestPackSelector.vue";
import Faq from "../custom/Faq.vue";

const { currentGameSlug } = useGameComposable();
const gameStore = useGameStore();

const packs = computed(() => {
  if (currentGameSlug === "counter-strike-2-boost") {
    return gameStore.getGamePacks.filter(
      (pack) => !pack.title.includes("Faceit")
    );
  }
  return gameStore.getGamePacks;
});

const isLoaded = ref(false);

const fakeCounter = computed(() => {
  if (currentGameSlug === "marvel-rivals-boost") {
    return true;
  }
  if (currentGameSlug === "fc-boost") {
    return true;
  }
  if (currentGameSlug === "path-of-exile-2-boost") {
    return true;
  }
  return false;
});

const gameFaqs = computed(() => {
  if (gameStore.getGame?.faqs) {
    return gameStore.getGame?.faqs;
  }
  return [];
});

function pageLoading() {
  isLoaded.value = true;
  window.removeEventListener("scroll", pageLoading);
}

onNuxtReady(() => {
  window.addEventListener("scroll", pageLoading);
});
</script>
